import React from "react"
import { observer } from "mobx-react-lite"
import styled from '~/ui/styled'

const Container = styled.View`
  padding: 16px;
  background-color: #ffffff;
  margin-top: 3px;
`
const CurViewInputBox = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const CurText = styled.Text<{ color?: string; size?: number; weight?: string | number }>`
  font-size: ${({ size }) => (size ? `${size}px` : "12px")};
  color: ${({ color }) => color};
  font-weight: ${({ weight }) => weight || 300};
`

const TextInput = styled.TextInput`
  height: 40px;
  border-width: 0; // 设置边框宽度为0，即去掉边框
  border-color: transparent; // 设置边框颜色为透明，确保边框不可见
  padding: 0;
`

const Input: React.FC<any> = ({ value, onChangeText, label, placeholder, operation }) => {
  return (
    <Container>
      <CurText weight={400} color="#a2a8af">
        {label}
      </CurText>

      <CurViewInputBox>
        <TextInput
          placeholder={placeholder}
          placeholderTextColor="#C8C8C8"
          onChangeText={(text) => onChangeText(text)}
          value={value}
        />
        {operation}
      </CurViewInputBox>
    </Container>
  )
}

export default observer(Input)
